import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from "../../utilities/axiosInstance";

let initialState = {
  isLoading: false,
  error: null,
  data: {}
};

export const getInfo = createAsyncThunk(
  "info/getInfo",
  async (_, thunkApi) => {
    try {
      const { data } = await axiosInstance.get(
        `/settings/info`
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateInfo = createAsyncThunk(
  "info/updateInfo",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/settings/info`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const infoSlice = createSlice({
  name: "info",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getInfo.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    })
      .addCase(getInfo.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload;
      })
      .addCase(getInfo.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateInfo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateInfo.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload;
      })
      .addCase(updateInfo.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});


export default infoSlice.reducer;